<template>
  <!-- 
    文件（主要图片）上传七牛
    @example
    ```
    <Uploader
      v-model="uploadedImages"
      :multiple="false"
      width="260px"
      height="208px"
      :limit-file-size="false"
      accept-type="image/webp,image/png,image/jpeg"
    />
    ```

    - `width`和`height`设置时，需手动调整预览图、占位图大小
    - `compress`：暂时不支持压缩上传
    - slots:
      - default: 占位元素
  -->
  <el-upload
    :action="UPLOAD_URL"
    class="uploader"
    :with-credentials="false"
    name="files"
    :headers="headers"
    :multiple="multiple"
    :accept="acceptType"
    :limit="multiple ? count : 1"
    list-type="picture-card"
    :before-upload="beforeUpload"
    :on-success="afterUpload"
		:on-remove="handleRemove"
    :on-exceed="handleExceed"
    :file-list="fileList"
		:class="isExceed ? 'hide-upload-box' : ''"
    :style="{width: width, height: height}"
  >

    <slot>
      <i class="el-icon-plus"></i>
    </slot>

		<div slot="tip" v-if="showTips && tips">
			<span>{{ tips }}</span>
		</div>
	</el-upload>
</template>

<script>
import * as imageConversion from 'image-conversion';
import { postImageToQiNiuApi, UPLOAD_API } from '@/api'
const BASE_URL = process.env.VUE_APP_BASE_URL


let UPLOAD_URL = BASE_URL + UPLOAD_API
if (BASE_URL.endsWith('/') && UPLOAD_API.startsWith('/')) {
  UPLOAD_URL = BASE_URL + UPLOAD_API.replace(/^\//, '')
}

export default {
  name: "Uploader",
  model: {
    prop: 'url',
    event: 'change'
  },
  props: {
    url: {
			type: String,
			default: ''
		},
		showTips: {
			type: Boolean,
			default: true,
		},
    /** 组件底部显示的提示文字 */
    tips: {
      type: String
    },
		/** 图片最大大小，单位：MB */
		maxSize: {
			type: Number,
			default: 3,
		},
		/** 是否限制上传的图片大小，如果不限制，`maxSize` 无效 */
		limitFileSize: {
			type: Boolean,
			default: true,
		},
		/** 上传前是否压缩图片 */
		compress: {
			type: Boolean,
			default: true
		},
    width: {
      type: String,
      default: '148px'
    },
    height: {
      type: String,
      default: '148px'
    },
    /** 是否多选 */
    multiple: {
      type: Boolean,
      default: false
    },
    /** 最多能选几张 */
    count: {
      type: Number,
      default: 6,
    },
    /** 可上传的文件类型 */
    acceptType: {
      type: String,
      default: 'image/webp,image/png,image/jpeg',
    }
  },
  data() {
    return {
      UPLOAD_URL,
      headers: {
        Authorization: `Bearer ${this.$store.state.user.token}`
      },
      fileList: [],
    }
  },
  computed: {
    isExceed() {
      let count = this.multiple ? this.count : 1
      return this.fileList.length >= count
    }
  },
  watch: {
    fileList: {
      deep: true,
      handler(newValue) {
        let urls = newValue.map(file => file.url).join(',')
        this.$emit('change', urls)
      }
    },
    url: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          let urls = newValue.split(',')
          this.fileList = urls.map(url => ({url}))
        }
      },
    },
  },
  methods: {
    handleRemove(_file, fileList) {
      this.fileList = fileList
    },
    async beforeUpload(file) {
      if (this.limitFileSize) {
        let isLessThanMaxSize = file.size / 1024 / 1024 < this.maxSize;
        if (!isLessThanMaxSize) {
          this.$message.warning(`文件大小不能超过${this.maxSize}MB！`)
          return false
        }
      }

      // if (this.compress) {
      //   let res = await imageConversion.compressAccurately(file, {
      //     size: 100,
      //     accuracy: 0.88,
      //   })
      // }

      return true
    },
    afterUpload(resp, _file, fileList) {
      if (resp.code === 0) {
        fileList.forEach(f => {
          if (f.response && f.response.code === 0 && f.response.data.storageUrl) {
            let uploadedURL = f.response.data.storageUrl ? 'https://'+f.response.data.storageUrl : ''
            if (uploadedURL) {
              f.url = uploadedURL
            }
          }
        })
        this.fileList = fileList
      } else {
        this.$message.error(resp.msg || '上传失败')
      }
    },
    handleExceed() {
      let count = this.multiple ? this.count : 1
      this.$message.warning(`最多可上传${count}张图片！`)
    },
  },
}
</script>

<style lang="less" scoped>
.hide-upload-box {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>